module.exports = __WEBPACK_EXTERNAL_MODULE_29__;


//////////////////
// WEBPACK FOOTER
// external "@angular/common"
// module id = 29
// module chunks = 0 1